import { ActionKind } from "@glide/app-description";
import type { AppDescriptionContext, ActionAvailability } from "@glide/function-utils";
import type { WireActionResult, WireActionResultBuilder } from "@glide/wire";
import { type WireActionHydrator, type WireActionInflationBackend } from "@glide/wire";
import type { StaticActionContext } from "../static-context";
import { type ActionDescriptor, ActionGroup } from "./action-descriptor";
import { type DescriptionToken, actionAvailabilityApps } from "./action-handler";
import { BaseActionHandler, tokenForProperty } from "./base";
import {
    type OpenWebViewActionDescription,
    makeLinkColumnPropertyDescriptor,
    webViewAppearancePropertyHandler,
} from "./open-link";

export class OpenWebViewActionHandler extends BaseActionHandler<OpenWebViewActionDescription> {
    public readonly kind = ActionKind.OpenWebView;

    // FIXME: Icon
    public readonly iconName = "link";

    public readonly name = "Open link in Web view";

    public get availability(): ActionAvailability {
        return actionAvailabilityApps;
    }

    public getDescriptor(): ActionDescriptor {
        return {
            name: this.name,
            group: ActionGroup.Interaction,
            groupItemOrder: 10,
            needsScreenContext: true,
            isLegacy: true,
            properties: [makeLinkColumnPropertyDescriptor(), webViewAppearancePropertyHandler],
        };
    }

    public getTokenizedDescription(
        desc: OpenWebViewActionDescription,
        env: StaticActionContext<AppDescriptionContext>
    ): readonly DescriptionToken[] | undefined {
        const token = tokenForProperty(desc.link, env);
        if (token === undefined) return undefined;
        return [token];
    }

    public inflate(
        _ib: WireActionInflationBackend,
        _desc: OpenWebViewActionDescription,
        arb: WireActionResultBuilder
    ): WireActionHydrator | WireActionResult {
        return arb.inflationError("Web View is not supported anymore");
    }
}
